import React, { lazy, Suspense } from 'react';

const LazyReceptionManagement = lazy(() => import('./ReceptionManagement'));

const ReceptionManagement = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyReceptionManagement {...props} />
  </Suspense>
);

export default ReceptionManagement;
